import { BsSliders } from "react-icons/bs";
import { LuSearch } from "react-icons/lu";
import { AiOutlinePlusSquare } from "react-icons/ai";
import { useState } from "react";
import { Button, Form, Input, Modal, Select, Table } from "antd";
import { adminColumn } from "../../customers/column";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { addAdmin, fetchAdmins } from "../../../api/auth";
import { toast } from "react-toastify";
import { fetchRoles } from "../../../api/setting";

export default function RolesTable() {
  const boxShadowStyle = {
    boxShadow: "0px 2px 9px 0px #00000008",
    userSelect: "none",
  };

  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState("");
  const { data } = useQuery(["admin-users", search], () => fetchAdmins(search));

  return (
    <div className="flex flex-col gap-3 bg-white rounded-lg p-5">
      <div className="flex items-center justify-between">
        <div className="tracking-[-0.4 px] font-dmsans font-bold text-[18px] text-[#070E05]">
          Users
        </div>
        <div className="flex items-center gap-[10px]">
          <div
            className="border-[1px] border-[#E9EFF4] bg-white rounded-lg p-2 cursor-pointer"
            title={`Search`}
            style={boxShadowStyle}
          >
            <div className="text-[14px] text-[#A0A3BD] leading-5 flex items-center gap-2 w-full h-full relative">
              <LuSearch className="text-[18px]" />
              <input
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                className="w-[200px] placeholder:text-[#A0A3BD] text-[13px] outline-none text-black bg-transparent"
                placeholder=" Type to Search"
              />
            </div>
          </div>
          <div
            onClick={() => setOpen(true)}
            className="bg-[#0000000D] p-2 rounded-[5px] cursor-pointer"
            title="Add user to role"
          >
            <div className="text-[#1B0A4B] font-bold text-[15px] font-Neurial flex items-center gap-1">
              <AiOutlinePlusSquare />
              <span>Add New</span>
            </div>
          </div>
        </div>
      </div>
      <div className="z-0">
        <Table dataSource={data?.admins || []} columns={adminColumn} />
      </div>
      <CreateAdminModal open={open} handleClose={() => setOpen(false)} />
    </div>
  );
}

const CreateAdminModal = ({ open, handleClose }) => {
  const queryClient = useQueryClient();
  const { data } = useQuery(["roles"], fetchRoles);

  const mutation = useMutation(addAdmin, {
    onSuccess: () => {
      queryClient.invalidateQueries("roles");
      queryClient.invalidateQueries("admin-users");
      toast.success("User added");
      handleClose();
    },
    onError: (e) => {
      toast.error(e.message);
    },
  });

  const onFinish = (values) => {
    console.log(values);
    mutation.mutate({ ...values, role: "admin" });
  };

  return (
    <Modal
      title="Create Role"
      open={open}
      footer={null}
      onCancel={() => handleClose()}
    >
      <Form layout="vertical" requiredMark onFinish={onFinish}>
        <Form.Item
          label="First Name"
          name="firstName"
          rules={[
            { required: true, type: "string", message: "Enter First Name" },
          ]}
        >
          <Input placeholder="John" />
        </Form.Item>

        <Form.Item
          label="Last Name"
          name="lastName"
          rules={[
            { required: true, type: "string", message: "Enter First Name" },
          ]}
        >
          <Input placeholder="Jima" />
        </Form.Item>

        <Form.Item
          label="Email Address"
          name="email"
          rules={[
            { required: true, type: "email", message: "Enter First Name" },
          ]}
        >
          <Input placeholder="Jima@gmail.com" />
        </Form.Item>

        <Form.Item
          label="Phone Number"
          name="phoneNumber"
          rules={[
            { required: true, type: "string", message: "Enter First Name" },
          ]}
        >
          <Input placeholder="080" />
        </Form.Item>

        <Form.Item
          label="Role"
          name="roleId"
          rules={[
            { required: true, type: "string", message: "Enter First Name" },
          ]}
        >
          <Select>
            {(data?.roles || []).map((role) => (
              <Select.Option value={role._id}>{role.title}</Select.Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          label="Password"
          name="password"
          rules={[
            { required: true, type: "string", message: "Enter First Name" },
          ]}
        >
          <Input.Password placeholder="*****" />
        </Form.Item>

        <Form.Item>
          <Button loading={mutation.isLoading} htmlType="submit" type="primary">
            Add User
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};
